import GovList from './views/gov-list.c';
export default GovList;
